<section class="page-container">
  <div class="flex flex-wrap items-center justify-between gap-2">
    <h1 class="main-heading">Discount</h1>
    <app-navpath></app-navpath>
  </div>
  <div class="content-container overflow-hidden">
    <h2 class="sub-heading w-full border-b">Manage Discount</h2>
    <div class="relative grid min-w-0 grid-cols-1 gap-4 xl:grid-cols-2">
      <div class="min-w-0">
        <div class="content-container min-w-0">
          <app-data-form
            [columns]="1"
            [dataFields]="[updateDiscounts[0]]"
            [dataName]="'discountAmount'"
            (clickUpdate)="onUpdateEvent($event)"
          ></app-data-form>
          <h2 class="sub-heading w-full border-b">COE Type : Bidding and OWN COE</h2>
          <div class="max-w-full overflow-x-auto">
            <app-data-table
              class="block min-w-[32rem]"
              [tableHeaders]="tableHeaders"
              [tableEntries]="coe_bidding"
            ></app-data-table>
          </div>
        </div>
      </div>
      <div class="min-w-0">
        <div class="content-container min-w-0">
          <app-data-form
            [columns]="1"
            [dataFields]="[updateDiscounts[1]]"
            [dataName]="'immediateDiscountAmount'"
            (clickUpdate)="onUpdateEvent($event)"
          ></app-data-form>
          <h2 class="sub-heading w-full border-b">COE Type : Immediate E and Immediate C</h2>
          <div class="max-w-full overflow-x-auto">
            <app-data-table
              class="block min-w-[32rem]"
              [tableHeaders]="tableHeaders"
              [tableEntries]="immediate"
            ></app-data-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
